import ServicePage from '../components/service/ServicePage'

export default function Serigrafi() {
  return <ServicePage service="screen" lang="tr" />
}
